import vueMainInstance from "../../main";

export default class SystemSettings {
  constructor() {
    this.groupId = null;

    this.delegation_google_distance_verification = null;
    this.delegation_google_distance_verification_allowed_difference = null;
    this.is_allowed_multiple_delegation_advance = null;

    this.delegation_number_setting_type = null;

    this.delegation_from_order_date_validation_type = null;
    this.delegation_from_order_date_change = null;
    this.delegation_from_order_country_change = null;
    this.delegation_from_order_transport_change = null;
    this.delegation_from_order_destination_change = null;
    this.delegation_from_order_start_end_location_change = null;
    this.delegation_order_confirm_is_required = null;
    this.delegation_order_number_setting_type = null;

    this.delegation_order_type = null;

    this.allowed_transport_types = null;
    this.allowed_transport_settlement = null;
    this.allowed_accommodation_settlement = null;
  }

  load(userId, groupId = null, loadUrl = "settings/system/get-full") {
    this.groupId = groupId;
    vueMainInstance.axios.post(loadUrl, { id: userId }).then(resp => {
      this.delegation_google_distance_verification = resp.data.delegation_google_distance_verification;
      this.delegation_google_distance_verification_allowed_difference = resp.data.delegation_google_distance_verification_allowed_difference;
      this.is_allowed_multiple_delegation_advance = resp.data.is_allowed_multiple_delegation_advance;
      this.delegation_number_setting_type = resp.data.delegation_number_setting_type;

      this.delegation_from_order_date_validation_type = resp.data.delegation_from_order_date_validation_type;
      this.delegation_from_order_date_change = resp.data.delegation_from_order_date_change;
      this.delegation_from_order_country_change = resp.data.delegation_from_order_country_change;
      this.delegation_from_order_transport_change = resp.data.delegation_from_order_transport_change;
      this.delegation_from_order_destination_change = resp.data.delegation_from_order_destination_change;
      this.delegation_from_order_start_end_location_change = resp.data.delegation_from_order_start_end_location_change;
      this.delegation_order_confirm_is_required = resp.data.delegation_order_confirm_is_required;
      this.delegation_order_number_setting_type = resp.data.delegation_order_number_setting_type;

      this.delegation_order_type = resp.data.delegation_order_type;

      this.allowed_transport_types = resp.data.allowed_transport_types;
      this.allowed_transport_settlement = resp.data.allowed_transport_settlement;
      this.allowed_accommodation_settlement = resp.data.allowed_accommodation_settlement;
    });
  }
}
